import React, {useEffect, useState} from "react";
import "./Malls.scss";
import {useHistory} from "react-router";
import {HomeData} from "../Home/HomeServices";
import {MallsData} from "./MallsServices";
import {useMall} from "../../hooks/useMall";
import {useDispatchMall} from "../../hooks/useDispatchMall";

function Malls() {

    //Hooks
    const history = useHistory();
    const setMall = useDispatchMall();

    //states
    const [malls,setMalls] = useState(null);


    useEffect(()=>{
       getMalls();
    },[])


    //Func
    const getMalls = async (mallId=null) => {
        try {
            let Malls = await MallsData();
            setMalls(Malls.data);
            // console.log(Malls);
        } catch (e) {
            // console.log(e);
        }
    }

    const goToMall = (mall) => {
        localStorage.setItem('mallId',mall.uid);
        localStorage.setItem('mallLogo',mall.header_image);
        localStorage.setItem('mallWhite',mall.logo);
        localStorage.setItem('mallName',mall.name);
        localStorage.setItem('mall',JSON.stringify(mall));
        localStorage.setItem('theme',JSON.stringify({
            primary:mall.primary_color?.color,
            secondary:mall.secondary_color?.color,
            tertiary:mall.tertiary_color?.color
        }));
        setMall(mall);
        // console.log("Mall : ",mall);
        // history.goBack();
        history.push("/home")
    }



    return(
        <div className="malls-container">
            <div className="malls-header">
                <span>انتخاب مرکز خرید</span>
                <i
                    onClick={()=>history.goBack()}
                    className="fa fa-arrow-left back_btn"></i>
            </div>

            {/*<div className="malls-last-visit">*/}
            {/*    <div className="malls-last-visit-titre">*/}
            {/*        <span>بر اساس آخرین مراجعه های شما</span>*/}
            {/*    </div>*/}

            {/*    <div className="malls-last-visit-list">*/}

            {/*        {malls && malls.slice(0, 2).map(mall=>{*/}
            {/*            return(*/}
            {/*                <div key={mall.uid}*/}
            {/*                onClick={()=>goToMall(mall)}*/}
            {/*                className="malls-last-visit-item">*/}
            {/*                    <img src={mall.image} alt=""/>*/}
            {/*                    <span>{mall.name}</span>*/}
            {/*                    /!*<span>ستاری</span>*!/*/}
            {/*                </div>*/}
            {/*            )*/}
            {/*        })}*/}
            {/*    </div>*/}
            {/*</div>*/}


            <div className="malls-list">

                <div className="malls-titre">
                    <span>مراکز خرید</span>
                </div>

                <div className="malls-list">

                    <div className="malls-list-row">

                        {malls && malls.map(mall=>{
                            return(
                                <div key={mall.uid} className="malls-item"
                                     onClick={()=>goToMall(mall)}
                                     style={{background: `rgba(0, 0, 0, .35) url(${mall.image})`}}>
                                    <span>{mall.name}</span>
                                </div>
                            )
                        })}

                    </div>

                </div>
            </div>

            {/*<div className="malls-titre-promote">*/}
            {/*    <span>تبلیغات مراکز خرید</span>*/}
            {/*</div>*/}

            {/*<div className="promote-malls">*/}
            {/*    {malls && malls.map(item=>{*/}
            {/*        return(*/}
            {/*            <div className="promote-malls-item" onClick={()=>goToMall(item)}>*/}
            {/*                {item.cover?<img src={item.cover} alt=""/>:null}*/}
            {/*                {item.name && item.cover?<span>{item.name}</span>:null}*/}
            {/*            </div>*/}
            {/*        )*/}
            {/*    })}*/}
            {/*</div>*/}


        </div>
    )
}

export {Malls}
